export default __webpack_public_path__ + "static/media/directions_bike.43005167.svg";